import React, { useCallback, useEffect, useState } from "react";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import TeclaEscEnter from "../../utils/Teclaescenter";
import { API_URL } from "../../utils/config";
import { fetchAutenticat } from "../../utils/auth";
import AjudaMestres from "./AjudaMestres";
import { BotoAjuda } from "./AjudaModal";

const COLOR_HEX_REGEX = /^#[0-9A-Fa-f]{6}$/;

function Detallstipusabsencia({
  mode,
  tipus,
  tipusLlista,
  onNavigate,
  onSave,
  onCancel,
  onCanviarMode,
  onDeleted,
}) {
  const isReadOnly = mode === "consultar" || mode === "esborrar";
  TeclaEscEnter(onCancel, null);
  const { empresaSeleccionada, rolUsuari } = useUserContext();

  const [codi, setCodi] = useState("");
  const [nom, setNom] = useState("");
  const [descripcio, setDescripcio] = useState("");
  const [color, setColor] = useState("");
  const [colorText, setColorText] = useState("");
  const [recuperablePerDefecte, setRecuperablePerDefecte] = useState(false);
  const [requereixJustificacio, setRequereixJustificacio] = useState(false);
  const [esBaixaLaboral, setEsBaixaLaboral] = useState(false);
  const [actiu, setActiu] = useState(true);
  const [menuAccions, setMenuAccions] = useState(false);
  const [mostraAjuda, setMostraAjuda] = useState(false);

  const resetForm = useCallback(() => {
    setCodi("");
    setNom("");
    setDescripcio("");
    setColor("");
    setColorText("");
    setRecuperablePerDefecte(true);
    setRequereixJustificacio(true);
    setEsBaixaLaboral(false);
    setActiu(true);
  }, []);

  useEffect(() => {
    if (tipus && mode !== "nou") {
      setCodi(tipus.Codi || "");
      setNom(tipus.Nom || "");
      setDescripcio(tipus.Descripcio || "");
      setColor(tipus.Color || "");
      setColorText(tipus.Color || "");
      setRecuperablePerDefecte(Number(tipus.RecuperablePerDefecte) === 1);
      setRequereixJustificacio(Number(tipus.RequereixJustificacio) === 1);
      setEsBaixaLaboral(Number(tipus.EsBaixaLaboral) === 1);
      setActiu(Number(tipus.Actiu) === 1);
    } else if (mode === "nou") {
      resetForm();
    }
    setMenuAccions(false);
  }, [tipus, mode, resetForm]);

  const handleColorPicker = (value) => {
    setColor(value);
    setColorText(value);
  };

  const handleColorText = (value) => {
    setColorText(value);
    if (COLOR_HEX_REGEX.test(value)) setColor(value);
  };

  const llista = Array.isArray(tipusLlista) ? tipusLlista : [];
  const indexActual = tipus
    ? llista.findIndex((t) => Number(t.idTipusAbsenciaEmpleats) === Number(tipus.idTipusAbsenciaEmpleats))
    : -1;
  const potNavegar = ["consultar", "modificar"].includes(mode) && llista.length > 1 && indexActual >= 0;

  const anarAnterior = () => {
    if (!potNavegar) return;
    const nouIndex = indexActual === 0 ? llista.length - 1 : indexActual - 1;
    onNavigate?.(llista[nouIndex]);
  };

  const anarSeguent = () => {
    if (!potNavegar) return;
    const nouIndex = indexActual === llista.length - 1 ? 0 : indexActual + 1;
    onNavigate?.(llista[nouIndex]);
  };

  const validar = () => {
    const errors = [];
    if (!codi.trim()) errors.push("El camp Codi és obligatori.");
    if (!nom.trim()) errors.push("El camp Nom és obligatori.");
    if (colorText.trim() && !COLOR_HEX_REGEX.test(colorText.trim())) {
      errors.push("El Color ha de tenir el format #RRGGBB.");
    }
    return errors;
  };

  const handleSubmit = async () => {
    if (mode !== "esborrar") {
      const errors = validar();
      if (errors.length > 0) {
        alert(`Errors trobats:\n${errors.join("\n")}`);
        return;
      }
    }

    const payload = {
      idEmpresa: empresaSeleccionada?.IdEmpresa || null,
      Codi: codi.trim(),
      Nom: nom.trim(),
      Descripcio: descripcio.trim() || null,
      Color: colorText.trim() || null,
      RecuperablePerDefecte: recuperablePerDefecte,
      RequereixJustificacio: requereixJustificacio,
      EsBaixaLaboral: esBaixaLaboral,
      Actiu: actiu,
    };

    try {
      if (mode === "nou") {
        const response = await fetchAutenticat(`${API_URL}/NouTipusAbsencia.php`, {
          method: "POST",
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (data.success) {
          onSave?.({ ...payload, idTipusAbsenciaEmpleats: data.idTipusAbsenciaEmpleats });
        } else {
          alert(`Error en crear el Tipus d'absència: ${data.message}`);
        }
      } else if (mode === "modificar") {
        payload.idTipusAbsenciaEmpleats = tipus.idTipusAbsenciaEmpleats;
        const response = await fetchAutenticat(`${API_URL}/ModificarTipusAbsencia.php`, {
          method: "POST",
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (data.success) {
          onSave?.({ ...tipus, ...payload });
        } else {
          alert(`Error en modificar el Tipus d'absència: ${data.message}`);
        }
      } else if (mode === "esborrar") {
        const response = await fetchAutenticat(`${API_URL}/EsborrarTipusAbsencia.php`, {
          method: "POST",
          body: JSON.stringify({
            idEmpresa: empresaSeleccionada?.IdEmpresa || null,
            idTipusAbsenciaEmpleats: tipus.idTipusAbsenciaEmpleats,
          }),
        });
        const data = await response.json();
        if (data.success) {
          onDeleted?.();
        } else {
          alert(`Error en esborrar el Tipus d'absència: ${data.message}`);
        }
      }
    } catch (error) {
      console.error("Error en l'operació del Tipus d'absència:", error);
      alert("S'ha produït un error en el procés.");
    }
  };

  const toggle = (checked, onChange) => (
    <span className="dv2-toggleRow">
      <span className="dv2-toggle">
        <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} />
        <span className="dv2-toggle-track" />
      </span>
    </span>
  );

  const camp = (label, required, content, mida = "mig") => {
    const extra =
      mida === "ample" ? "dv2-field--ample" : mida === "llarg" ? "dv2-field--llarg" : mida === "curt" ? "dv2-field--curt" : "dv2-field--mig";
    return (
      <label className={`dv2-field ${extra}`}>
        <span className={`dv2-label ${required && !isReadOnly ? "dv2-required" : ""}`}>{label}</span>
        {content}
      </label>
    );
  };

  const titol =
    mode === "nou"
      ? "Nou tipus d'absència"
      : mode === "esborrar"
      ? "Esborrar tipus d'absència"
      : mode === "modificar"
      ? "Modificar tipus d'absència"
      : "Tipus d'absència · Fitxa";

  return (
    <form className="dv2-entity" onSubmit={(e) => e.preventDefault()}>
      {mostraAjuda && <AjudaMestres pestanya="tipusabsencia" onTancar={() => setMostraAjuda(false)} />}
      <div className="dv2-pageHeader">
        <div className="dv2-pageHeader-main">
          <div className={`dv2-pageHeader-icon ${mode === "esborrar" ? "is-danger" : ""}`} aria-hidden="true">
            {mode === "esborrar" ? "🗑️" : "📅"}
          </div>
          <div>
            <h1 className="dv2-pageHeader-title">{titol}</h1>
            <p className="dv2-pageHeader-subtitle">
              {mode === "nou" ? "Omple el catàleg d'absència." : mode === "esborrar" ? "Aquesta acció no es pot desfer si el tipus ja s'ha fet servir." : nom || "Dades del tipus"}
            </p>
          </div>
        </div>
        <div className="dv2-pageHeader-actions">
          <BotoAjuda title="Com funcionen els Tipus d'absència" onClick={() => setMostraAjuda(true)} />
          <button type="button" className="dv2-btn" onClick={onCancel}>
            Tornar
          </button>
          {mode === "consultar" && tincPermis(rolUsuari, "MODIFICAR") && (
            <button type="button" className="dv2-btn dv2-btn--primary" onClick={() => onCanviarMode?.("modificar")}>
              Modificar
            </button>
          )}
          {mode === "consultar" && tincPermis(rolUsuari, "ESBORRAR") && (
            <div style={{ position: "relative" }}>
              <button type="button" className="dv2-btn" onClick={() => setMenuAccions((v) => !v)}>
                Més accions
              </button>
              {menuAccions && (
                <div className="dv2-menu" style={{ right: 0, top: "42px" }}>
                  <button
                    type="button"
                    className="dv2-menu-item is-danger"
                    onClick={() => {
                      setMenuAccions(false);
                      onCanviarMode?.("esborrar");
                    }}
                  >
                    Esborrar
                  </button>
                </div>
              )}
            </div>
          )}
          {(mode === "nou" || mode === "modificar") && (
            <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSubmit}>
              Desar
            </button>
          )}
          {mode === "esborrar" && (
            <button type="button" className="dv2-btn dv2-btn--danger" onClick={handleSubmit}>
              Esborrar tipus
            </button>
          )}
        </div>
      </div>

      {mode === "esborrar" && (
        <div className="dv2-banner dv2-banner--danger">
          Aquesta acció no es pot desfer. Si el tipus ja s'ha fet servir, el servidor pot no deixar-lo esborrar.
        </div>
      )}

      <div className="dv2-entity-body">
        <section className="dv2-card">
          <div className="dv2-card-head">
            <span className="dv2-card-num">1</span>
            <h2 className="dv2-card-title">Identificació</h2>
          </div>
          <div className="dv2-fields dv2-fields--sizes">
            {camp("Codi", true, isReadOnly ? <span className="dv2-value">{codi || "—"}</span> : <input type="text" className="dv2-input" value={codi} maxLength={45} autoFocus onChange={(e) => setCodi(e.target.value)} />, "curt")}
            {camp("Nom", true, isReadOnly ? <span className="dv2-value">{nom || "—"}</span> : <input type="text" className="dv2-input" value={nom} maxLength={100} onChange={(e) => setNom(e.target.value)} />, "llarg")}
            {camp(
              "Descripció",
              false,
              isReadOnly ? (
                <span className="dv2-value">{descripcio || "Sense descripció."}</span>
              ) : (
                <textarea className="dv2-textarea" value={descripcio} maxLength={255} onChange={(e) => setDescripcio(e.target.value)} />
              ),
              "ample"
            )}
            {camp(
              "Color",
              false,
              isReadOnly ? (
                <span className="dv2-value" style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                  {color ? (
                    <>
                      <span style={{ width: 14, height: 14, borderRadius: "50%", border: "1px solid #94a3b8", backgroundColor: color, display: "inline-block" }} />
                      {color}
                    </>
                  ) : (
                    "—"
                  )}
                </span>
              ) : (
                <div className="dv2-controlRow">
                  <input type="color" className="dv2-input" style={{ width: 48, padding: 4 }} value={COLOR_HEX_REGEX.test(color) ? color : "#cccccc"} onChange={(e) => handleColorPicker(e.target.value)} />
                  <input type="text" className="dv2-input" value={colorText} maxLength={7} placeholder="#RRGGBB" onChange={(e) => handleColorText(e.target.value)} />
                </div>
              ),
              "mig"
            )}
          </div>
        </section>

        <section className="dv2-card">
          <div className="dv2-card-head">
            <span className="dv2-card-num">2</span>
            <h2 className="dv2-card-title">Comportament</h2>
          </div>
          <div className="dv2-fields dv2-fields--sizes">
            {camp("Recuperable per defecte", false, isReadOnly ? <span className="dv2-value">{recuperablePerDefecte ? "Sí" : "No"}</span> : toggle(recuperablePerDefecte, setRecuperablePerDefecte), "curt")}
            {camp("Requereix justificació", false, isReadOnly ? <span className="dv2-value">{requereixJustificacio ? "Sí" : "No"}</span> : toggle(requereixJustificacio, setRequereixJustificacio), "curt")}
            {camp("És baixa laboral", false, isReadOnly ? <span className="dv2-value">{esBaixaLaboral ? "Sí" : "No"}</span> : toggle(esBaixaLaboral, setEsBaixaLaboral), "curt")}
            {camp("Actiu", false, isReadOnly ? <span className="dv2-value">{actiu ? "Sí" : "No"}</span> : toggle(actiu, setActiu), "curt")}
          </div>
        </section>
      </div>

      {(potNavegar || mode === "nou" || mode === "modificar" || mode === "esborrar") && (
        <div className="dv2-entity-dock">
          {potNavegar && (
            <div className="dv2-recordNav">
              <button type="button" className="dv2-btn dv2-recordNav-btn" onClick={anarAnterior} title="Anterior">
                ‹
              </button>
              <span className="dv2-recordNav-info">
                {indexActual + 1} / {llista.length}
              </span>
              <button type="button" className="dv2-btn dv2-recordNav-btn" onClick={anarSeguent} title="Següent">
                ›
              </button>
            </div>
          )}
          {(mode === "nou" || mode === "modificar" || mode === "esborrar") && (
            <div className="dv2-footerActions">
              <button type="button" className="dv2-btn" onClick={onCancel}>
                Cancel·lar
              </button>
              {mode === "esborrar" ? (
                <button type="button" className="dv2-btn dv2-btn--danger" onClick={handleSubmit}>
                  Esborrar tipus
                </button>
              ) : (
                <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSubmit}>
                  {mode === "nou" ? "Desar tipus" : "Desar"}
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </form>
  );
}

export default Detallstipusabsencia;
